import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Grid,
  Box,
  TableContainer,
  CircularProgress,
  IconButton,
  Collapse,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import StatusTextDispaly from "../models/status/DeliveryCompleted";
import { getRefQty, getStdQty, getVariance } from "../sasl/common/variance";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import { presentFormatedData } from "../functionalComponents/dataFormatFunctions";
import getColor from "../sasl/models/status/statusColors";
import StyledButton from "../models/Button";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../containers/actions/types";
import BackDropLoading from "../models/BackDrop";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    margin: "20px auto",
    padding: theme.spacing(2),
  },
  headerAuditText: {
    marginBottom: theme.spacing(2),
    textAlign: "center",
    fontWeight: "500",
  },
  button: {
    backgroundColor: "#f5b7b1",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#f1948a",
    },
  },
  table: {
    marginTop: theme.spacing(2),
  },
  statusButton: {
    backgroundColor: "#58d68d",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#45b39d",
    },
  },
  approvedStatus: {
    backgroundColor: "#76d7c4",
    color: "#fff",
    borderRadius: "5px",
    padding: "5px 10px",
  },
  negotiationStatus: {
    backgroundColor: "#f7b7a3",
    color: "#fff",
    borderRadius: "5px",
    padding: "5px 10px",
  },
  headerTable: {
    marginBottom: theme.spacing(2),
    backgroundColor: "#f8f9f9",
    borderRadius: "5px",
    padding: theme.spacing(2),
  },
  headerItem: {
    marginBottom: theme.spacing(1),
  },
  headerLabel: {
    fontWeight: "bold",
  },
  headerContainer: {
    margin: "20px auto",
    padding: "16px",
    backgroundColor: "#f8f9fa",
    boxShadow: "none",
    border: "0.5px solid #BEBEBEC7",
  },
  table: {
    width: "100%",
  },
  header: {
    fontWeight: "500",
      border: "none",
    whiteSpace:'nowrap'
  },
  value: {
    fontSize: "14px",
    color: "#212529",
    border: "none",
  },
  status: {
    fontSize: "14px",
    borderRadius: "20px",
    padding: "4px 12px",
    textAlign: "center",
    display: "inline-block",
    whiteSpace: "nowrap",
  },
}));

const groupData = (data) => {
  const grouped = {};
  data.forEach((item) => {
    const key = `${item.productCode}-${item.productName}`;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(item);
  });
  return Object.entries(grouped).map(([key, values]) => ({
    groupKey: key,
    productCode: values[0].productCode,
    productName: values[0].productName,
    rows: values,
  }));
};

const ForwardGenealogyTable = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { cmoDetails, materialData, rmpmBatchDetails } = props;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openGroups, setOpenGroups] = useState({});
  const [error, setError] = useState(false);
  const [responseData, setResponseData] = useState([]); 
  const [downloadError, setDownloadError] = useState(false);

  const handleToggle = (groupKey) => {
    setOpenGroups((prev) => ({
      ...prev,
      [groupKey]: !prev[groupKey],
    }));
  };

  useEffect(() => {
    setLoading(true);
    const data = {
      arNumber: rmpmBatchDetails?.analyticalReportNumber,
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchConsumptionForForwardGenealogy`,
        data
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const groupedData = res.data.data ? groupData(res.data.data) : [];
          setTableData(groupedData);
          setResponseData(res.data.data ? res.data.data : [])
        } else {
          setError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        setError(true);
      });
  }, []);

  const downloadReport = () => {
    setDownloadError(false)
    let tablelist = responseData.length > 0 ? groupData(responseData).map((val) => {
      return {
        productCodeDescription: `${val.productCode} / ${val.productName}`,
        consumptionDetails: val.rows
      }
    }) : [];

    const reqObj = {
      headerData: {
        cmoName: cmoDetails?.organization_name,
        plantId: cmoDetails?.vendorPlant,
        materialCodeDescription: (materialData?.materialCode && materialData?.materialDescription) ? `${materialData?.materialCode} / ${materialData?.materialDescription}` : null,
        rmpmBatchNumber: rmpmBatchDetails?.analyticalReportNumber,
        uom: rmpmBatchDetails?.inventoryUOM,
        receivedQty: rmpmBatchDetails?.actualQuantityReceived,
        currentlyInStockQty: rmpmBatchDetails?.valuatedUnrestrictedUsedStock,
        expiryDate: rmpmBatchDetails.inventoryExpiryDate ? moment(rmpmBatchDetails.inventoryExpiryDate).format(
          "DD-MMM-YYYY"
        ).toUpperCase()
       : null,
      },
      tableData: tablelist,
    };

    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait. Downloading the file....",
    });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/downloadForwardGeneologyExcelFile`,
        reqObj
      )
      .then((res) => {
        if (res.data.status) {
          const byteCharacters = atob(res.data.fileData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // Create a download link and trigger the download
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = res.data.fileName || "report.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          setDownloadError(true)
          //console.log("There is an error in downloading excel file");
        }
        dispatch({
                  type: DESTROY_BACKDROP,
                });
      })
      .catch((err) => {
        console.error(err.message);
        setDownloadError(true)
        dispatch({
                  type: DESTROY_BACKDROP,
                });
      });
  };

  return (
    <React.Fragment>
      <BackDropLoading />
    <Paper className={classes.container}>
      <Typography variant="h5" className={classes.headerAuditText}>
        Forward genealogy report
      </Typography>
      {rmpmBatchDetails && Object.keys(rmpmBatchDetails).length > 0 ? (
        <React.Fragment>
          {/* Header Section */}
          <Paper className={classes.headerContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell align="left" className={classes.header}>
                    CMO Name
                  </TableCell>
                  <TableCell align="left" className={classes.header}>
                    Plant ID
                  </TableCell>
                  <TableCell align="left" className={classes.header}>
                                      {"Material code / description"}
                  </TableCell>
                  <TableCell align="left" className={classes.header}>
                    RM/PM batch number
                  </TableCell>
                  <TableCell align="left" className={classes.header}>
                    UoM
                  </TableCell>
                  <TableCell align="right" className={classes.header}>
                    Received qty
                  </TableCell>
                  <TableCell align="right" className={classes.header}>
                    Currently in stock qty
                  </TableCell>
                  <TableCell align="left" className={classes.header}>
                    Expiry date
                  </TableCell>

                  <TableCell
                    align="center"
                    className={classes.header}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell align="left" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}>
                      {presentFormatedData(cmoDetails?.organization_name)}
                    </Typography>
                  </TableCell>
                  <TableCell align="left" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}>
                      {presentFormatedData(cmoDetails?.vendorPlant)}
                    </Typography>
                  </TableCell>
                  <TableCell align="left" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}>
                      {materialData?.materialCode &&
                      materialData?.materialDescription
                        ? `${materialData?.materialCode} / ${materialData?.materialDescription}`
                        : " - / - "}
                    </Typography>
                  </TableCell>
                  <TableCell align="left" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}>
                      {presentFormatedData(rmpmBatchDetails?.analyticalReportNumber)} 
                    </Typography>
                  </TableCell>
                  <TableCell align="left" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}>
                      {presentFormatedData(rmpmBatchDetails?.inventoryUOM)} 
                    </Typography>
                  </TableCell>
                  <TableCell align="right" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}>
                      {presentFormatedData(rmpmBatchDetails?.actualQuantityReceived)} 
                    </Typography>
                  </TableCell>
                  <TableCell align="right" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}> 
                                          {rmpmBatchDetails?.valuatedUnrestrictedUsedStock ? parseFloat(rmpmBatchDetails?.valuatedUnrestrictedUsedStock).toFixed(2): ' - '}
                    </Typography>
                  </TableCell>
                  <TableCell align="left" style={{ border: "none", whiteSpace:'nowrap' }}>
                    <Typography className={classes.value}>
                      {/* {presentFormatedData(rmpmBatchDetails?.inventoryExpiryDate)}  */}
                      {rmpmBatchDetails?.inventoryExpiryDate ? (
                moment(rmpmBatchDetails.inventoryExpiryDate).format(
                  "DD-MMM-YYYY"
                ).toUpperCase()
              ) : (
                "-"
              )}
                    </Typography>
                  </TableCell>
                  <TableCell style={{ border: "none" }}>
                    <StyledButton
                      color="primary"
                      //   className={classes.search}
                      // disabled
                      onClick={downloadReport}
                      style={{ borderRadius: "2rem", whiteSpace:'nowrap' }}
                    >
                      Download report
                    </StyledButton>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            </Paper>
            
            {downloadError && (
                          <Box
                            style={{
                              border: "2px solid rgb(255,0,0)",
                              backgroundColor: "rgb(255,240,240)",
                              Opacity: 1,
                              textAlign: "center",
                              padding: "0.8rem",
                              fontSize: "0.875rem",
                              marginBottom: "1.5em",
                            }}
                          >
                            {" "}
                            <Typography variant="body2">
                              Something went wrong. Please try again later.
                            </Typography>
                          </Box>
                        )}
          {/* Audit Report Table */}
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      width: "5%",
                      background: "#FFE4CC",
                      border: "2px solid #FFA95E",
                      borderRight: "none",
                    }}
                  />
                  <TableCell
                    align="left"
                    style={{
                      width: "30%",
                      background: "#FFE4CC",
                      border: "2px solid #FFA95E",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Product Code / Description
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      width: "15%",
                      background: "#FFE4CC",
                      border: "2px solid #FFA95E",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Consumed Quantity
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      width: "15%",
                      background: "#FFE4CC",
                      border: "2px solid #FFA95E",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    UoM
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      width: "15%",
                      background: "#FFE4CC",
                      border: "2px solid #FFA95E",
                      borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Batch Number
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      width: "20%",
                      background: "#FFE4CC",
                      border: "2px solid #FFA95E",
                      // borderRight: "none",
                      borderLeft: "none",
                    }}
                  >
                    Batch Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                <TableRow style={{ height: 100 }}>
                                                                                <TableCell colSpan={6}>
                                                                                  <div style={{ textAlign: 'center' }}>
                                                                                    <CircularProgress color='primary' thickness={5} />
                                                                                  </div>
                                                                                </TableCell>
                                                                              </TableRow>
                ):
                  error ? (
                  <TableRow
                    style={{
                      border: "2px solid rgb(255,0,0)",
                      backgroundColor: "rgb(255,240,240)",
                      Opacity: 1,
                      textAlign: "center",
                      padding: "0.8rem",
                      fontSize: "0.875rem",
                    }}
                  >
                    <TableCell colSpan={6} align="center">
                      {"Something went wrong. Please try again."}
                    </TableCell>
                  </TableRow>
                ) : tableData && tableData.length > 0 ? (
                  tableData.map((group) => (
                    <React.Fragment key={group.groupKey}>
                      <TableRow style={{ width: "5%" }}>
                        <TableCell>
                          <IconButton
                            onClick={() => handleToggle(group.groupKey)}
                            size="small"
                          >
                            {openGroups[group.groupKey] ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell align="left" style={{ width: "30%" }}>
                          {group.productCode} / {group.productName}
                        </TableCell>
                        <TableCell style={{ width: "15%" }} />
                        <TableCell style={{ width: "15%" }} />
                        <TableCell style={{ width: "15%" }} />
                        <TableCell style={{ width: "20%" }} />
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            paddingBottom: 0,
                            paddingTop: 0,
                            padding: 0,
                          }}
                          colSpan={6}
                        >
                          <Collapse
                            in={openGroups[group.groupKey]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <Table>
                              <TableBody>
                                {group.rows.map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell
                                      align="left"
                                      style={{ width: "5%" }}
                                    />
                                    <TableCell
                                      align="left"
                                      style={{ width: "30%" }}
                                    ></TableCell>
                                    <TableCell
                                      align="left"
                                      style={{ width: "15%" }}
                                    >
                                      {row.consumedQuantity}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{ width: "15%" }}
                                    >
                                      {row.UOM}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      style={{ width: "15%" }}
                                    >
                                      {row.vendorBatchNumber}
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      style={{ width: "20%" }}
                                        >
                                            <StatusTextDispaly
            statusText={row.statusDescription}
            bgColor={getColor(row.statusID )}
          />
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} style={{ textAlign: "center" }}>
                      No Records Found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </React.Fragment>
      ) : (
        <div>
          <Typography
            style={{
              textAlign: "center",
              border: "1px solid",
              padding: "2rem",
            }}
          >
            No Records Found.
          </Typography>
        </div>
      )}
      </Paper>
      </React.Fragment>
  );
};

export default ForwardGenealogyTable;
